import { render, staticRenderFns } from "./fkYD.vue?vue&type=template&id=52610539&scoped=true&"
import script from "./fkYD.vue?vue&type=script&lang=js&"
export * from "./fkYD.vue?vue&type=script&lang=js&"
import style0 from "./fkYD.vue?vue&type=style&index=0&id=52610539&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52610539",
  null
  
)

export default component.exports